'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOBILE = exports.TABLET = exports.DESKTOP = undefined;
var _responsiveModes;
var _DesktopMac = require('@material-ui/icons/DesktopMac');
var _DesktopMac2 = _interopRequireDefault(_DesktopMac);
var _Tablet = require('@material-ui/icons/Tablet');
var _Tablet2 = _interopRequireDefault(_Tablet);
var _Smartphone = require('@material-ui/icons/Smartphone');
var _Smartphone2 = _interopRequireDefault(_Smartphone);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DESKTOP = exports.DESKTOP = 'desktop',
  TABLET = exports.TABLET = 'tablet',
  MOBILE = exports.MOBILE = 'mobile';
var responsiveModes = (_responsiveModes = {}, _defineProperty(_responsiveModes, DESKTOP, {
  name: DESKTOP,
  icon: _DesktopMac2.default,
  minWidth: 1200,
  maxWidth: Number.MAX_SAFE_INTEGER,
  default: '100%'
}), _defineProperty(_responsiveModes, TABLET, {
  name: TABLET,
  icon: _Tablet2.default,
  minWidth: 800,
  maxWidth: 1200,
  default: 800
}), _defineProperty(_responsiveModes, MOBILE, {
  name: MOBILE,
  icon: _Smartphone2.default,
  minWidth: 0,
  maxWidth: 800,
  default: 400
}), _responsiveModes);
exports.default = responsiveModes;